"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TitaniumExtractionCenter = void 0;
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const Tags_1 = require("../Tags");
const MoonExpansion_1 = require("../../moon/MoonExpansion");
const Resources_1 = require("../../Resources");
const CardRenderer_1 = require("../render/CardRenderer");
const Units_1 = require("../../Units");
const MoonCard_1 = require("./MoonCard");
const Size_1 = require("../render/Size");
class TitaniumExtractionCenter extends MoonCard_1.MoonCard {
    constructor() {
        super({
            name: CardName_1.CardName.TITANIUM_EXTRACTION_CENTER,
            cardType: CardType_1.CardType.AUTOMATED,
            tags: [Tags_1.Tags.BUILDING],
            cost: 14,
            reserveUnits: Units_1.Units.of({ titanium: 2 }),
            metadata: {
                description: 'Spend 2 titanium. Increase your titanium production 1 step for every 2 raised steps of Mining Rate.',
                cardNumber: 'M26',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.minus().titanium(2).br.br;
                    b.production((pb) => pb.titanium(1)).nbsp(Size_1.Size.SMALL).slash().moonMiningRate({ amount: 2 });
                }),
            },
        });
    }
    produce(player) {
        const miningRate = MoonExpansion_1.MoonExpansion.moonData(player.game).miningRate;
        const productionIncrease = Math.floor(miningRate / 2);
        player.addProduction(Resources_1.Resources.TITANIUM, productionIncrease, { log: true });
    }
    play(player) {
        super.play(player);
        this.produce(player);
        return undefined;
    }
}
exports.TitaniumExtractionCenter = TitaniumExtractionCenter;
//# sourceMappingURL=TitaniumExtractionCenter.js.map